import { __decorate } from "tslib";
import { Route } from '../core';
var ServiceMobileGlobal = /*@__PURE__*/ (function () {
    function ServiceMobileGlobal() {
    }
    ServiceMobileGlobal.get = function (response) {
        return response;
    };
    ServiceMobileGlobal = __decorate([
        Route('/vlux/subscriptions/servicemobile-global.json')
    ], ServiceMobileGlobal);
    return ServiceMobileGlobal;
}());
export { ServiceMobileGlobal };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/servicemobile-global.ts
// module id = null
// module chunks = 